import keymirror from "../utils/keymirror";

export const FeedConstants = keymirror(
    {
        FEED_REQUEST: null,
        FEED_SUCCESS: null,
        FEED_FAILURE: null,
        RESET_FEED: null
    },
    "feed"
);



// WEBPACK FOOTER //
// ./src/constants/feed.constants.js